import PropTypes from 'prop-types'
import React from 'react'
import * as Yup from 'yup'
import { titleCase } from 'title-case'

import {
  Form,
  FormikCheckbox,
  FormikDialog,
  FormikTextField,
  FIELD_REQUIRED,
} from 'src/modules/ui'

import { useAdmin } from '../hooks'

const RoleForm = ({ handleSubmit, isSubmitting }) => {
  // Group up permissions
  const { permissions } = useAdmin()
  const groups = [...new Set(permissions.map(perm => perm.group))]
  const permissionByGroup = groups.map(group => ({
    name: titleCase(group),
    permissions: permissions.filter(perm => perm.group === group),
  }))

  return (
    <Form>
      <Form.InputGroup>
        <FormikTextField
          fullWidth
          label="Name"
          margin="normal"
          name="name"
          type="text"
        />
        <FormikTextField
          fullWidth
          label="Description"
          margin="normal"
          name="description"
          type="text"
        />
      </Form.InputGroup>
      {permissionByGroup.map(({ name, permissions }, idx) => (
        <Form.InputGroup title={titleCase(name)} key={idx}>
          <Form.CheckboxGroup>
            {permissions.map(({ id, description }) => (
              <FormikCheckbox
                key={id}
                label={description}
                name="permissions"
                value={String(id)}
              />
            ))}
          </Form.CheckboxGroup>
        </Form.InputGroup>
      ))}
    </Form>
  )
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required(FIELD_REQUIRED),
  description: Yup.string().notRequired().nullable(),
})

export const EditRolesModal = ({ role, ...props }) => {
  const { updateRoles } = useAdmin()

  const stringPermissions = role.permissions.map(perm => String(perm))
  const initialValues = { ...role, permissions: stringPermissions }

  return (
    <>
      <FormikDialog
        initialValues={initialValues}
        onSubmit={values => updateRoles(values)}
        submitText="Update"
        successNotification={{
          image: 'mushrooms',
          message: 'Role updated!',
        }}
        title="Edit Role"
        validationSchema={validationSchema}
        {...props}
      >
        <RoleForm />
      </FormikDialog>
    </>
  )
}

EditRolesModal.propTypes = {
  trigger: PropTypes.func,
}

export const AddRolesModal = ({ ...props }) => {
  const { addRoles } = useAdmin()

  const initialValues = {
    name: '',
    description: '',
    permissions: [],
  }

  return (
    <>
      <FormikDialog
        initialValues={initialValues}
        onSubmit={values => addRoles(values)}
        submitText="Add"
        successNotification={{
          image: 'mushrooms',
          message: "Role added!\n\nWe'll make sure your users don't misbehave.",
        }}
        title="Add Role"
        validationSchema={validationSchema}
        {...props}
      >
        <RoleForm />
      </FormikDialog>
    </>
  )
}

AddRolesModal.propTypes = {
  trigger: PropTypes.func,
}
